import { ContentLoader } from './styles';
export default ContentLoader;
